import { ReactNode } from "react";

interface IProps {
  href: string;
  text: ReactNode;
}

const ContactLink = ({ href, text }: IProps) => {
  return (
    <a
      href={href}
      className="underline"
      target="_blank"
      rel="noopener noreferrer"
    >
      {text}
    </a>
  );
};

export { ContactLink };
